angular.module('impactx.MenuDirectives').directive('ixUserInfo', function () {
    return {
        restrict: 'EA',
        templateUrl: 'shared/menu/templates/userinfo-menu.tmpl.html'
    }
});